module.exports = __webpack_public_path__ + "img/icon_1_1.cbfbaa73.png";